<div class="carousel d-flex align-items-center justify-content-between">
  <button type="button" class="btn btn-simple" (click)="updateCarouselPosition('prev')" [disabled]="carouselScrollLeftEnd">
    <i class="fa fa-angle-left"></i>
  </button>
  <div class="list-wrapper" #carouselWrapRef>
    <ng-container *ngIf="list.length">
      <ul [style.left]="listPosition" #carouselListRef>
        <li *ngFor="let item of list" [class.active]="item.selected" (click)="selectYear(item)">
          {{item.year}}
        </li>
      </ul>
    </ng-container>
  </div>
  <button type="button" class="btn btn-simple" (click)="updateCarouselPosition('next')" [disabled]="carouselScrollRightEnd">
    <i class="fa fa-angle-right"></i>
  </button>
</div>
